/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import {
  CLEAR_STATE,
  SET_HOME,
  SET_TOKEN,
  SET_CLIENT,
  SET_DEVICE,
  SET_DEVICENOTIFY,
  SET_LANG,
  SET_USER,
  SET_PERM,
  SET_MENU,
  SET_NOTIFY,
  SET_BADGE,
  SET_AUTHEN,
  SET_POS,
} from '../actions/appAction';

const initialState = {
  home: '',
  token: '',
  client: '',
  device: '',
  devicenotify: '',
  lang: 'th',
  user: {
    id: '',
    name: '',
    image: '',
    logo: '',
    branch_name: '',
  },
  authen: {
    remember: false,
    username: '',
    password: '',
  },
  perm: {},
  menu: [],
  notify: {
    count: 0,
    pos_archive: 0,
    pos_approve: 0,
  },
  pos: {
    pos_device: '',
    pos_return: '',
    pos_cancel: '',
    pos_delete: '',
    pos_discount: '',
  },
  badge: {
    quotation: 0,
    invoice: 0,
    job_order: 0,
    purchase_request: 0,
    purchase_order: 0,
    receive: 0,
    export_invite: 0,
    export_request: 0,
  },
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_STATE:
      return { ...initialState, authen: action.payload, client: action.client };
    case SET_TOKEN:
      return { ...state, token: action.payload };
    case SET_HOME:
      return { ...state, home: action.payload };
    case SET_CLIENT:
      return { ...state, client: action.payload };
    case SET_DEVICE:
      return { ...state, device: action.payload };
    case SET_DEVICENOTIFY:
      return { ...state, devicenotify: action.payload };
    case SET_LANG:
      return { ...state, lang: action.payload };
    case SET_USER:
      return { ...state, user: action.payload };
    case SET_PERM:
      return { ...state, perm: action.payload };
    case SET_MENU:
      return { ...state, menu: action.payload };
    case SET_NOTIFY:
      return { ...state, notify: action.payload };
    case SET_BADGE:
      return { ...state, badge: action.payload };
    case SET_AUTHEN:
      return { ...state, authen: action.payload };
    case SET_POS:
      return { ...state, pos: action.payload };
    default:
      return state;
  }
}
